module.exports = __webpack_public_path__ + "static/media/project-parser.1de86d3d.avif";